module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close view","expand":"Expand view","unexpand":"Reduce view"},"de":{"close":"Ansicht schließen","expand":"Ansicht erweitern","unexpand":"Ansicht verkleinern"},"fr":{"close":"Fermer la vue","expand":"Agrandir la vue","unexpand":"Réduire la vue"},"it":{"close":"Chiudi vista","expand":"Espandi vista","unexpand":"Riduci vista"}}')
  delete Component.options._Ctor
}
